module.exports = __webpack_public_path__ + "img/header-memoireRingsPlatinum@2x.e830d9b.webp";